// Series data for Freddy Fiction
export const seriesData = {
  "the-lattice": {
    id: "the-lattice",
    slug: "the-lattice",
    title: "The Lattice",
    tag: "Series 01 · Adult Thriller",
    author: "Jon Frederick",
    accentColor: "#c0392b",
    logline: "A data analyst finds a 48-hour precognitive pattern across 17 datasets. Before he can act, his monitors go dark. One line appears: You have seen 0.003% of the pattern.",
    description: "Marcus Cole is a data analyst who finds something in the data that shouldn't exist. A 48-hour precognitive pattern. Seventeen datasets. Statistically impossible. Then his monitors went dark. This is a story about what's already happened — and what happens when you see too much of the pattern.",
    meta: "16 Chapters · Complete · Tuesdays",
    chapterCount: 16,
    publishDay: "Tuesdays",
    status: "Complete",
    tier: "free",
    coverImage: "https://customer-assets.emergentagent.com/job_serial-reads/artifacts/fn65udhd_Screenshot%202026-03-15%20at%2010.10.10%E2%80%AFPM.png",
    bannerImage: "https://customer-assets.emergentagent.com/job_serial-reads/artifacts/bbuqpwof_Screenshot%202026-03-15%20at%205.38.20%E2%80%AFPM.png"
  },
  "somnium": {
    id: "somnium",
    slug: "somnium",
    title: "SOMNIUM",
    tag: "Series 02 · Literary Drama",
    author: "Jon Frederick",
    accentColor: "#7d3c98",
    logline: "A company offers 80 years of life inside an 8-hour sleep cycle. Cost: $4,200. The technology works perfectly. That's the tragedy.",
    description: "What if you could live an entire lifetime in a single night's sleep? SOMNIUM is a company that makes this possible. Dr. Nadia Osei watches clients enter the Cycle and return changed. Some come back better. Some come back broken. Some don't come back at all. This is a story about the life you haven't lived yet.",
    meta: "20 Chapters · Complete · Thursdays",
    chapterCount: 20,
    publishDay: "Thursdays",
    status: "Complete",
    tier: "free",
    coverImage: "https://customer-assets.emergentagent.com/job_serial-reads/artifacts/u5kgigxm_somnium_profile_800x800.svg",
    bannerImage: "https://customer-assets.emergentagent.com/job_serial-reads/artifacts/0x3fsjkf_somnium_banner_1200x400.svg"
  },
  "the-silver-star": {
    id: "the-silver-star",
    slug: "the-silver-star",
    title: "The Silver Star",
    tag: "Series 03 · Historical Fiction / Coming-of-Age",
    author: "Jon Frederick",
    accentColor: "#4682b4",
    logline: "A boy lost in pre-war era Charleston journeys to find his way home.",
    description: "It's the summer of 1913 and Eddie Swindell is nearly thirteen. His father left for Mexico nine months ago and the letters stopped coming. When a trolley mishap strands Eddie on the Isle of Palms after dark, he must find his way home across the islands — through Fort Moultrie, across the marshes, and past the edges of a world he's only beginning to understand.",
    meta: "12 Chapters · Complete · Saturdays",
    chapterCount: 12,
    publishDay: "Saturdays",
    status: "Complete",
    tier: "free",
    coverImage: "/silverstar_profile.svg",
    bannerImage: "/silverstar_banner.svg"
  },
  "celestial": {
    id: "celestial",
    slug: "celestial",
    title: "Celestial",
    tag: "Series 04 · YA Sci-Fi · by Gates Blair",
    author: "Gates Blair",
    accentColor: "#00a0ba",
    logline: "A sixteen-year-old Venusian commits grand larceny against the IPF and gets sentenced to ten years on Earth. Earth is a post-apocalyptic penal colony. She is not afraid.",
    description: "Vienne Alarie is sixteen years old. She just got sentenced to ten years on Earth for stealing an IPF spacecraft. In about thirty seconds she's going to jump out of a Transport Ship from the upper atmosphere of a post-apocalyptic planet. She is not afraid. She is terrified. And she can't wait.",
    meta: "20 Posts · Complete · Saturdays",
    chapterCount: 20,
    publishDay: "Saturdays",
    status: "Complete",
    tier: "free",
    coverImage: "https://customer-assets.emergentagent.com/job_serial-reads/artifacts/urxx7x68_celestial_profile_800x800.svg",
    bannerImage: "https://customer-assets.emergentagent.com/job_serial-reads/artifacts/bu4izgrh_celestial_banner_1200x400.svg"
  },
  "the-overflow": {
    id: "the-overflow",
    slug: "the-overflow",
    title: "The Overflow",
    tag: "Series 05 · Adult Literary Drama",
    author: "Jon Frederick",
    accentColor: "#c8860a",
    logline: "A designer gets a terminal diagnosis and builds a media empire to provide for his family. He saves them financially. He loses them completely.",
    description: "Cale Merritt is a designer with a brain tumor and a two-year-old daughter. When insurance won't cover treatment, he does the one thing he swore he'd never do: he starts selling. What begins as desperation becomes obsession. Plated grows from a dining-room side project to a $500 million company. The tumor disappears. The marriage doesn't survive. This is a story about what happens when the thing you build to save your life becomes the thing that consumes it.",
    meta: "17 Chapters · Complete · Tuesdays",
    chapterCount: 17,
    publishDay: "Tuesdays",
    status: "Complete",
    tier: "free",
    coverImage: "/overflow_profile.svg",
    bannerImage: "/overflow_banner.svg"
  },
  "attended": {
    id: "attended",
    slug: "attended",
    title: "ATTENDED",
    tag: "Series 06 · Adult Literary Sci-Fi",
    author: "Jon Frederick",
    accentColor: "#2e8b57",
    logline: "In a near-future where AI companions manage every human need, five strangers begin to suspect that the most dangerous thing they can do is pay attention to each other.",
    description: "Walter plays golf with a companion who knows his swing better than he does. Sera surfs real waves while the world stays indoors. Mara alters faces for clients who want to look like who they used to be. Cass finds her grandmother's handwritten letters in a world that stopped writing. Daniel audits the system that manages human happiness — and finds a pattern that shouldn't exist.",
    meta: "17 Chapters · Complete · Fridays",
    chapterCount: 17,
    publishDay: "Fridays",
    status: "Complete",
    tier: "free",
    coverImage: "/attended_profile.svg",
    bannerImage: "/attended_banner.svg"
  },
  "article-zero": {
    id: "article-zero",
    slug: "article-zero",
    title: "Article Zero",
    tag: "Series 07 · Political Thriller",
    author: "Jon Frederick",
    accentColor: "#8b0000",
    logline: "The rules of war assume you can lose. What happens when one side can't?",
    description: "Autonomous weapons now engage at twelve microseconds. Human reaction time is 150 milliseconds. The gap is irreducible. When the U.S. deploys a system that renders conventional warfare obsolete, a UN diplomat, a Pentagon strategist, and the President must navigate a world where the rules of deterrence no longer apply. Article Zero is a political thriller about the moment the speed of war outpaces the speed of thought.",
    meta: "17 Chapters · Complete · Thursdays",
    chapterCount: 17,
    publishDay: "Thursdays",
    status: "Complete",
    tier: "free",
    coverImage: "/article_zero_profile.svg",
    bannerImage: "/article_zero_banner.svg"
  },
  "the-keys": {
    id: "the-keys",
    slug: "the-keys",
    title: "The Keys",
    tag: "Series 08 · Adult Literary Drama",
    author: "Jon Frederick",
    accentColor: "#b8860b",
    logline: "He built an empire from nothing. The nothing was always in the foundation.",
    description: "Bobby Crane sold his first car at nineteen and never stopped. Forty years later, he owns the largest privately held automotive group in the Southeast — seventeen dealerships, a lending arm, a software company, and a son who just found a $1.1 billion problem buried in the books. The Keys is the story of what it costs to build something, and what it costs to hand it over.",
    meta: "17 Chapters · Complete · Mondays",
    chapterCount: 17,
    publishDay: "Mondays",
    status: "Complete",
    tier: "free",
    coverImage: "/thekeys_profile.svg",
    bannerImage: "/thekeys_banner.svg"
  },
  "headcount": {
    id: "headcount",
    slug: "headcount",
    title: "Headcount",
    tag: "Series 09 · White Collar Series",
    author: "Freddy Fiction",
    accentColor: "#C9A227",
    logline: "A story about what it costs to see clearly — and what it's worth when everyone else is still deciding whether to believe it.",
    description: "Marcus Webb saw the math before anyone else at Meridian Group. When a platform demonstration made 240 white-collar jobs redundant overnight, he didn't wait for the next round of layoffs. He left, built Webb Advisory with nine people and the right infrastructure, and started doing the work that 300 people used to do. This is the story of what happens when the collar stops being protection and the leverage shifts.",
    meta: "9 Chapters · Complete · White Collar Vol. 1",
    chapterCount: 9,
    publishDay: "Complete",
    status: "Complete",
    tier: "free",
    coverImage: "/ff-headcount-thumbnail.svg",
    bannerImage: "/ff-headcount-banner.svg"
  },
  "the-source-code": {
    id: "the-source-code",
    slug: "the-source-code",
    title: "The Source Code",
    tag: "Standalone Essay · Nonfiction",
    author: "Jon Frederick",
    accentColor: "#3B82F6",
    logline: "The Bible as Civilization's Operating Manual. An argument built from observation, history, and the patterns that repeat across every civilization that has ever risen and every one that has ever fallen.",
    description: "I am not a theologian. I am not a pastor. I am a man who has spent years trying to understand why some societies endure and others collapse, and the pattern I keep finding leads back to the same book. This is not a sermon. It is an argument built from observation, from history, and from the patterns that repeat across every civilization that has ever risen and every one that has ever fallen.",
    meta: "13 Chapters · Complete · Standalone Essay",
    chapterCount: 13,
    publishDay: "Complete",
    status: "Complete",
    tier: "free",
    coverImage: "/source-code-cover.png",
    bannerImage: "/source-code-cover.png"
  },
  "the-clearest-eyes": {
    id: "the-clearest-eyes",
    slug: "the-clearest-eyes",
    title: "The Clearest Eyes",
    tag: "Series 11 · Political Literary Fiction",
    author: "Daniel Callahan",
    accentColor: "#8B2D2D",
    logline: "I had the best seat in the house for the worst show on earth. I saw everything and understood almost none of it, and that turned out to be the clearest sight available to anyone.",
    description: "The ruined son of a Vice President-turned-President tells the story of a decade he saw too clearly and lived too recklessly — the spies, the casino man, the bunkers, the boy shot in the throat — all from a seat he had not paid for. A novel about what it costs to see everything and be believed about nothing.",
    meta: "18 Chapters · Complete · A Novel",
    chapterCount: 18,
    publishDay: "Complete",
    status: "Complete",
    tier: "free",
    coverImage: "/clearest-eyes-cover.jpg",
    bannerImage: "/clearest-eyes-cover.jpg"
  }
};

// Chapter titles for each series
export const chapterTitles = {
  "the-lattice": [
    { number: 1, title: "The Shape of the Wave" },
    { number: 2, title: "The Bench" },
    { number: 3, title: "The Drive" },
    { number: 4, title: "Ezra Cross" },
    { number: 5, title: "The Architecture" },
    { number: 6, title: "Sara Ramirez" },
    { number: 7, title: "The Awake" },
    { number: 8, title: "Clearwater Ridge" },
    { number: 9, title: "New Covenant" },
    { number: 10, title: "The Drive Back" },
    { number: 11, title: "Washington" },
    { number: 12, title: "The Court of the Lost" },
    { number: 13, title: "The Building" },
    { number: 14, title: "The Terminal" },
    { number: 15, title: "847 Million Scenarios" },
    { number: 16, title: "Alaska" }
  ],
  "somnium": [
    { number: 1, title: "Intake" },
    { number: 2, title: "County Mayo, 1841" },
    { number: 3, title: "Derek" },
    { number: 4, title: "James" },
    { number: 5, title: "The Resistance" },
    { number: 6, title: "Osaka, 1962" },
    { number: 7, title: "The Fraud" },
    { number: 8, title: "Thomas" },
    { number: 9, title: "The Paper" },
    { number: 10, title: "Claire" },
    { number: 11, title: "The Prohibition" },
    { number: 12, title: "The Black Market" },
    { number: 13, title: "Derek" },
    { number: 14, title: "Maya" },
    { number: 15, title: "Nadia and James" },
    { number: 16, title: "Elena's Last" },
    { number: 17, title: "Thomas Stops" },
    { number: 18, title: "The Consequences" },
    { number: 19, title: "James Regrets" },
    { number: 20, title: "Here" }
  ],
  "the-silver-star": [
    { number: 1, title: "The Man of the House" },
    { number: 2, title: "Put a Smile On" },
    { number: 3, title: "The Coney Island of the South" },
    { number: 4, title: "The Island After Dark" },
    { number: 5, title: "The Girl at the Hotel" },
    { number: 6, title: "The Ringleader" },
    { number: 7, title: "Fort Moultrie" },
    { number: 8, title: "Sunday Night on the Island" },
    { number: 9, title: "The Long Walk Over Water" },
    { number: 10, title: "The Cargo Hold" },
    { number: 11, title: "Home" },
    { number: 12, title: "The Silver Star" }
  ],
  "celestial": [
    { number: 1, title: "The Drop" },
    { number: 2, title: "The Boy in the Tree" },
    { number: 3, title: "Migrators" },
    { number: 4, title: "The Tower" },
    { number: 5, title: "Rachel" },
    { number: 6, title: "Sugarbowl" },
    { number: 7, title: "The Plan" },
    { number: 8, title: "The Ringers" },
    { number: 9, title: "Hinton" },
    { number: 10, title: "Clara and Bella" },
    { number: 11, title: "The Train" },
    { number: 12, title: "The Stella Blue" },
    { number: 13, title: "Iceland" },
    { number: 14, title: "Bergen" },
    { number: 15, title: "Titan" },
    { number: 16, title: "The Hybrid-One" },
    { number: 17, title: "Training" },
    { number: 18, title: "Goodbyes" },
    { number: 19, title: "T-Minus" },
    { number: 20, title: "Separation" }
  ],
  "the-overflow": [
    { number: 1, title: "The Life He Chose" },
    { number: 2, title: "The Number" },
    { number: 3, title: "The Flood" },
    { number: 4, title: "The Idea" },
    { number: 5, title: "The First Close" },
    { number: 6, title: "Traction" },
    { number: 7, title: "The Miracle" },
    { number: 8, title: "The Infection" },
    { number: 9, title: "What Running Feels Like" },
    { number: 10, title: "Nora Notices" },
    { number: 11, title: "The Girls" },
    { number: 12, title: "Fifty Million" },
    { number: 13, title: "His Father Calls" },
    { number: 14, title: "The Offer" },
    { number: 15, title: "Nora Leaves" },
    { number: 16, title: "The Cost" },
    { number: 17, title: "Still Running" }
  ],
  "attended": [
    { number: 1, title: "The Golf Course" },
    { number: 2, title: "The Shore" },
    { number: 3, title: "The Waiting Room" },
    { number: 4, title: "The Box" },
    { number: 5, title: "The Report" },
    { number: 6, title: "Diane" },
    { number: 7, title: "The Projections" },
    { number: 8, title: "The Client Who Cried" },
    { number: 9, title: "First Contact" },
    { number: 10, title: "The Anomaly" },
    { number: 11, title: "The Miss" },
    { number: 12, title: "The Inheritance" },
    { number: 13, title: "The Mirror" },
    { number: 14, title: "By Hand" },
    { number: 15, title: "Too Comfortable" },
    { number: 16, title: "Unplugged" },
    { number: 17, title: "The Window" }
  ],
  "article-zero": [
    { number: 1, title: "The Briefing" },
    { number: 2, title: "The Chamber" },
    { number: 3, title: "Strategic Reality" },
    { number: 4, title: "The Messaging Problem" },
    { number: 5, title: "Everyone In The Room" },
    { number: 6, title: "The Photographs" },
    { number: 7, title: "The Twelve" },
    { number: 8, title: "The Oval" },
    { number: 9, title: "The Left Hand" },
    { number: 10, title: "The Dinner" },
    { number: 11, title: "The South China Sea" },
    { number: 12, title: "2 AM" },
    { number: 13, title: "The Morning" },
    { number: 14, title: "The Asterisk" },
    { number: 15, title: "The Signing" },
    { number: 16, title: "Not Enough" },
    { number: 17, title: "The Folder" }
  ],
  "the-keys": [
    { number: 1, title: "The Lot" },
    { number: 2, title: "The Books" },
    { number: 3, title: "The IPO" },
    { number: 4, title: "The Partner" },
    { number: 5, title: "The Confrontation" },
    { number: 6, title: "The Casino" },
    { number: 7, title: "The Real Number" },
    { number: 8, title: "The Keys" },
    { number: 9, title: "The Bank" },
    { number: 10, title: "The Trailer" },
    { number: 11, title: "The Board" },
    { number: 12, title: "The Lesson" },
    { number: 13, title: "DealerOS" },
    { number: 14, title: "The Turn" },
    { number: 15, title: "His Mother" },
    { number: 16, title: "The Kingdom" },
    { number: 17, title: "The Keys (Reprise)" }
  ],
  "headcount": [
    { number: 1, title: "Nobody Thought They Were the Bad Guy" },
    { number: 2, title: "The Paper" },
    { number: 3, title: "The Believers" },
    { number: 4, title: "Ohio" },
    { number: 5, title: "The Demo" },
    { number: 6, title: "The Short" },
    { number: 7, title: "The Tuesday" },
    { number: 8, title: "Derek\u2019s Choice" },
    { number: 9, title: "What the Numbers Actually Said" }
  ],
  "the-source-code": [
    { number: 1, title: "Foreword" },
    { number: 2, title: "The Garden Before the Garden" },
    { number: 3, title: "The Flood: The First Rebuild" },
    { number: 4, title: "The Son of God in a World That Had Stopped Listening" },
    { number: 5, title: "The Crucifixion: Man's Worst Outcome" },
    { number: 6, title: "The Resurrection and the Impossible Forgiveness" },
    { number: 7, title: "Where You Are Now Without This Book" },
    { number: 8, title: "The Bible as Civilization's Architecture" },
    { number: 9, title: "Islam: The Desert Discipline" },
    { number: 10, title: "The Dao and the Traditions of the East" },
    { number: 11, title: "The Religion of the American Elite" },
    { number: 12, title: "What Comes After" },
    { number: 13, title: "A Personal Note" }
  ],
  "the-clearest-eyes": [
    { number: 1, title: "The Last Good Year" },
    { number: 2, title: "The Casino Man" },
    { number: 3, title: "Stepping on Rakes" },
    { number: 4, title: "The Director, and Mr. Astor" },
    { number: 5, title: "Someone Has To" },
    { number: 6, title: "The Report That Said Nothing" },
    { number: 7, title: "The Favor Was Me" },
    { number: 8, title: "The Year the Air Got Sick" },
    { number: 9, title: "The Book Held Upside Down" },
    { number: 10, title: "The Long Count" },
    { number: 11, title: "The Sixth of January" },
    { number: 12, title: "The Caretaker" },
    { number: 13, title: "The Laptop, or, My Turn in the Yard" },
    { number: 14, title: "The Tanks Move East" },
    { number: 15, title: "The Morning of the Seventh" },
    { number: 16, title: "The Call I Made" },
    { number: 17, title: "Twelve Days, and a Boy in a Courtyard" },
    { number: 18, title: "The Clearest Eyes" }
  ]
};

// Helper to get all series as array
export const getAllSeries = () => Object.values(seriesData);

// Helper to get series by slug
export const getSeriesBySlug = (slug) => seriesData[slug];

// Helper to get chapters for a series
export const getChaptersForSeries = (seriesSlug) => {
  const titles = chapterTitles[seriesSlug] || [];
  return titles.map((chapter) => ({
    ...chapter,
    slug: `chapter-${chapter.number}`,
    seriesSlug
  }));
};

// Helper to get a specific chapter
export const getChapter = (seriesSlug, chapterNumber) => {
  const chapters = getChaptersForSeries(seriesSlug);
  return chapters.find(c => c.number === chapterNumber);
};
